import { pipe } from 'rxjs/internal/util/pipe';
import { filter } from 'rxjs/operators/filter';
import { map } from 'rxjs/operators/map';
import { Store } from 'vuex';
import { RootStoreState } from '../../store';

export function hasSearchQuery(store: Store<RootStoreState>) {
  return pipe(
    map(() => store.state.search.query),
    filter(query => !!query.trim())
  );
}
